module.exports = __webpack_public_path__ + "static/media/rogue3.47f16c17.jpg";